var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69023 7.33795C8.57341 7.22078 8.41485 7.15541 8.2497 7.15541C8.08455 7.15541 7.926 7.22077 7.80918 7.33795L0.184972 14.9618C0.0671052 15.0783 0.000695647 15.2372 1.37256e-06 15.403C-0.000346299 15.5689 0.0653679 15.7281 0.182542 15.8453C0.300061 15.9628 0.458961 16.0282 0.624812 16.0278C0.790664 16.0275 0.949555 15.9607 1.06603 15.8429L8.24973 8.65952L14.1515 14.5609C14.268 14.6778 14.4265 14.7435 14.592 14.7435C14.7572 14.7435 14.9157 14.6778 15.0326 14.5609L21.4409 8.15225V10.536C21.4409 10.8802 21.7201 11.1591 22.064 11.1591C22.4082 11.1591 22.687 10.8802 22.687 10.536V6.62307C22.687 6.45756 22.6213 6.29937 22.5045 6.18254C22.3877 6.06572 22.2291 6 22.064 6H18.151C17.8068 6 17.5279 6.27885 17.5279 6.62307C17.5279 6.96694 17.8068 7.24614 18.151 7.24614H20.5852L14.5921 13.2393L8.69023 7.33795Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.d7bae36e.svg";
export { ForwardRef as ReactComponent };